export const loginSuccess = (userId, fullName, email, image) => ({
  type: "LOGIN_SUCCESS",
  payload: { userId, fullName, email, image },
});

export const setAgentIdUse = (agentId) => ({
  type: "SET_AGENT_ID",
  payload: { agentId },
});

// Applied once the session has been restored from GET /users/me on app boot.
// Carries the role, which the route guard and header both read.
export const setSession = ({ userId, fullName, email, image, role }) => ({
  type: "SET_SESSION",
  payload: { userId, fullName, email, image, role },
});

export const clearSession = () => ({ type: "CLEAR_SESSION" });
